module.exports = __webpack_public_path__ + "icons/check-green.8937f9384bb7c517600c235e7e9b1e13.svg";